import _ from 'lodash'

const stringUtil = {
  /**
   * 将字符串转化成数组,默认分隔符是','
   * @param str 要分隔的字符串 比如'1,2,3'
   * @param separator 字符串分隔符
   * @return Array 返回一个数组  [1,2,3]
   */
  stringToArrayWithSep(str, separator = ',') {
    if (!_.isString(str)) {
      throw new Error('the input str is not a String!')
    }
    return str.trim().split(separator)
  },
  /**
   * 将字符串转化成数组,默认分隔符是','
   * @param str 要分隔的字符串 比如'1,2,3'
   * @param separator 字符串分隔符
   * @return Array 返回一个数组  [1,2,3]
   */
  stringToArrayWithSepNumber(str, separator = ',') {
    if (!_.isString(str)) {
      throw new Error('the input str is not a String!')
    }
    const arr = str.trim().split(separator)
    const newArr = []
    arr.forEach((item) => {
      newArr.push(Number(item))
    })
    return newArr
  },
  /**
   * 将数组转成字符串，默认分隔符是','
   * @param array  将要被转换的数组 比如：[1,2,3]
   * @param separator
   * @return String 返回一个字符串 '1, 2, 3', 如果是空数组则返回一个空字符串
   */
  arrayToStringWithSep(array, separator = ',') {
    if (!_.isArray(array)) {
      throw new Error('the input array is not a Array!')
    }
    let str = ''
    array.forEach((v) => {
      str += `${v}${separator}`
    })
    return str.length === 0 ? str : str.substr(0, str.length - 1)
  }
}
export default stringUtil
